import { useEffect, useState } from "react";
import { FormProvider } from "../../../../../../common/provider/form/Form.provider";
import { Form, Input, Image } from "antd";
import { OperationFoldersService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { SimpleInput } from "../../../../../../common/components/simpleInput";
import style from "./style.module.scss";
import { CustomButton } from "../../../../../../common/components/CustomButton/CustomButton";
import { useParams } from "react-router";
import { FaFile } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import { API_BASE_URL_IMAGE } from "../../../../../../utilities/API_CONSTANT";
import { DynamicUploadMediaList } from "../../../../../../common/components/Upload/DynamicUploadMediaList";

type OperationFoldersFormType = {
  onFinish: () => void;
  initialValue?: any;
};

function OperationFoldersForm({ onFinish, initialValue }: OperationFoldersFormType) {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [enableEdit, setEnableEdit] = useState(false);

  useEffect(() => {
    if (initialValue) {
      setEnableEdit(initialValue.generated);
      const mediaFiles = initialValue.mediaFiles.map((file: any) => ({
        label: file?.basename,
        value: file["@id"] || "",
        contentUrl: file?.contentUrl,
        mediaType: file?.mediaType,
      }));
      setMediaList(mediaFiles);
      form.setFieldsValue({
        name: initialValue.name,
        operation: id ? `/api/operations/${id}` : null,
      });
    }
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const uploaded = form.getFieldValue("mediaFiles") || [];
      const allMedia = [...mediaList, ...uploaded].map((f) => f.value);
      const fileId = parseInt(initialValue?.["@id"].split("/").pop(), 10);

      const dataToPost = {
        name: values.name,
        mediaFiles: allMedia,
        operation: id ? `/api/operations/${id}` : null,
        ...(initialValue ? { "@id": `/api/operation_folders/${fileId}` } : {}),
      };

      const res = initialValue
        ? await OperationFoldersService.updateFolder(fileId, dataToPost)
        : await OperationFoldersService.createFolder(dataToPost);

      if (res?.status === HttpStatusCode.Ok || res?.status === HttpStatusCode.Created) {
        onFinish();
        form.resetFields();
        setMediaList([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const handleDelete = (idx: any) => {
    setMediaList((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleDownload = (url: any) => {
    const link = document.createElement("a");
    link.href = `${API_BASE_URL_IMAGE}${url}`;
    link.download = url.split("/").pop();
    link.click();
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={onSubmitHandler}
        onFinishFailed={(err) => console.log("err", err)}
      >
        <div className="d-none">
          <SimpleInput Form={Form} label="ID" name="id" customInput={<Input />} />
        </div>

        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Nom"
                name="name"
                rules={[{ required: true, message: `Ce champ est requis` }]}
                customInput={<Input readOnly={enableEdit} />}
              />
            </div>
          </div>

          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <label className={style.form__team_text}>Pièce jointe</label>
              { !enableEdit && (
                <SimpleInput
                  Form={Form}
                  name="mediaFiles"
                  customInput={
                    <DynamicUploadMediaList
                      form={form}
                      name="mediaFiles"
                    />
                  }
                />
              )}
            </div>
          </div>

          {mediaList.length > 0 && (
            <div className={style.media_grid}>
              {mediaList.map((media: any, idx) => (
                <div key={idx} className={style.media_card}>
                  {media.mediaType === "image" ? (
                    <>
                      <div  className={style.image_wrapper}>
                      <Image
                        src={`${API_BASE_URL_IMAGE}${media.contentUrl}`}
                        preview={true}
                        style={{ width: "100%", height: 130, objectFit: "cover", borderRadius: "8px 8px 0 0" }}
                      />
                      </div>
                       <div className={style.image_name}>
                        <span className={style.scrolling_text}>{media.label}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={style.image_wrapper}>
                      <div className={style.file_icon_wrapper}>
                        <FaFile className={style.file_icon} />
                      </div>
                      </div>
                       <div className={style.image_name}>
                        <span className={style.scrolling_text}>{media.label}</span>
                      </div>
                    </>
                  )}

                  
                    <div className={style.media_overlay_action}>
                      <IoMdDownload className={style.icon_button} onClick={() => handleDownload(media.contentUrl)} />
                      {!enableEdit && (
                        <MdDelete className={style.icon_button} onClick={() => handleDelete(idx)} />
                      )}
                    </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {!enableEdit && (
          <div className={style.form__action_wrapper}>
            <CustomButton type="submit" className={style.form__action_button} isLoading={isLoadingSubmit}>
              Enregistrer
            </CustomButton>
          </div>
        )}
      </FormProvider>
    </div>
  );
}

export default OperationFoldersForm;
